'use client'
import React from 'react'
import Link from 'next/link'
import { Card, CardBody, CardFooter, Image, Button } from '@nextui-org/react'
Card
import Title from '@/library/blocks/typography/Title'
import Styling from '@/library/styling'

export default function MarketList({ marketList }) {
  return (
    <div className="mb-12">
      <Title title="Markets" className="mb-6 ml-2" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {marketList.map((market) => (
          <Link key={market.slug} href={`/uae/instruments/markets/${market.slug}`} className="block h-full">
            <Card className="h-full min-w-64 hover:scale-[1.02] transition-transform duration-200" isPressable>
              <CardBody className="p-0 overflow-hidden relative h-48">
                {market.image ? (
                  <Image
                    alt={market.alt || market.name}
                    className="w-full h-full object-cover"
                    src={market.image}
                    radius="none"
                    width="100%"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                    <span className="text-4xl font-bold text-gray-300 uppercase">
                      {market.slug.substring(0, 3)}
                    </span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-4 z-10">
                  <h3 className="text-white font-bold text-xl">{market.name}</h3>
                </div>
              </CardBody>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
